const canDrag = ({ node: { navigationItem } }) => (
  !(navigationItem.isPrimary || navigationItem.isSecondary)
);

export default canDrag;
